import { render, staticRenderFns } from "./CreateForms.vue?vue&type=template&id=768f9b96"
import script from "./CreateForms.vue?vue&type=script&lang=js"
export * from "./CreateForms.vue?vue&type=script&lang=js"
import style0 from "./CreateForms.vue?vue&type=style&index=0&id=768f9b96&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports